//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resume from "./component/resume.vue";
import commportallogin from "@/pcpage/hr/recruitment/portal/commportallogin";
import privacyPolicy from "./component/privacyPolicy.vue";
export default {
  extends: commportallogin,
  name: "submitResume",
  components: {
    resume,
    privacyPolicy,
  },
  data() {
    return {
      step: 1,
      resumeType: "1",
      url: "api/api/getApplyJobInfo",
      record: {}, //
      ifcheckbox: false,
      completeLoadingBool: false,
      resumeInfo: {
        resumename: "",
        description: "",
        issponsorvisa: '',
        portalfilelist: [],
        educationlist: [],
        experiencelist: [],
      },
      addResumeInfo: {
        act: "add",
        educationlist: [],
        experiencelist: [],
      },
      restaurants: [],
      statusTitle: {
        1: "Submit Resume",
        2: "Submit Resume",
      },
      resumes: [
        {
          label: "Saved Resume",
          value: "1",
        },
        {
          label: "New Resume",
          value: "2",
        },
      ],
      channelList: [],
      usertype: '1',
      isShowMessageBox: false,
      rcid: '',
      uuid: '',
    };
  },
  methods: {
    completeLoading() {
      this.completeLoadingBool = true;
    },
    async doLoadRecord() {
      let RCid = this.$route.query.RCid;
      this.rcid = RCid;
      this.$set(this.resumeInfo, "channel", RCid);
      if (!this.isNotNullOrEmpty(RCid)) {
        this.$set(this.resumeInfo, "channel", "10000");
      }
      let uuid = this.$route.query.uuid;
      this.uuid = uuid;
      let oQuery = {
        uuid: uuid,
        ifresume: "1",
      };
      await this.axios.post(this.url, oQuery).then(({ data }) => {
        if (data.code == "1") {
          this.record = data.data.record;
          this.addResumeInfo["portalid"] = this.record.portalid;
          this.addResumeInfo["resumeid"] = this.record.resumeid;
          this.$set(this.resumeInfo, "portalid", this.record.portalid);
          this.$set(this.resumeInfo, "resumeid", this.record.resumeid);
        }
      });
    },
    async goNext(index) {
      let flag = true;
      this.goTop();
      if (index == 2) {
        flag = await this.checkForm3(this.resumeInfo);
      }
      if (flag) {
        this.step = index;
      }
    },
    goTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    submitForm() {
      //提交后端
      let submitUrl = "api/api/portalLogin/saveResumeByJOb";
      let oQuery = {
        record: this.resumeInfo,
      };
      oQuery.record["jobuuid"] = this.record.jobuuid;
      this.axios.post(submitUrl, oQuery).then(({ data }) => {
        if (data.code == "1") {
          let msg = data.data.msg;
          if (this.isNotNullOrEmpty(msg)) {
            this.$msgDailog.showMsgBox({
              title: msg,
            });
            return;
          }
          this.$router.push({
            path: "/portal/successOperate",
            query: {
              showtype: "resume",
            },
          });
        }
      });
    },
    async loadResumeList() {
      let resumeUrl = "api/api/portalLogin/getResumeList";
      let params = {};
      await this.axios
        .post(resumeUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            this.restaurants = data.data.record;
          }
        })
        .catch((error) => console.log(error));
    },
    async findChannel() {
      let url = "api/api/findChannel";
      let oQuery = {};
      await this.axios.post(url, oQuery).then(({ data }) => {
        if (data.code == "1") {
          this.channelList = data.data.list;
        }
      });
    },
    async getBaseInfo() {
      const { data: res } = await this.axios.post(
        "api/api/portalLogin/getPortalUserInfo",
        {}
      );
      if (res.code == 1) {
        this.usertype = res.data.record.usertype;
        if (this.usertype == '2') {
          this.$set(this.resumeInfo, "channel", "10000");
        }
        this.getFirstResume(res.data.record.resumelist[0].resumeid);
      }
    },
    async getFirstResume(id) {
      const { data: res } = await this.axios.post(
        "api/api/portalLogin/getPortalResumeInfo",
        {
          record: {
            resumeid: id,
          },
        }
      );
      if (res.code == 1) {
        console.log("resume", res);
        this.resumeInfo.description = res.data.record.description;
        this.resumeInfo.educationlist = res.data.record.educationlist;
        this.resumeInfo.experiencelist = res.data.record.experiencelist;
        this.resumeInfo.introduction = res.data.record.introduction;
        this.resumeInfo.portalid = res.data.record.portalid;
        this.resumeInfo.resumeid = res.data.record.resumeid;
        this.resumeInfo.resumename = res.data.record.resumename;
        this.resumeInfo.portalfilelist = res.data.record.portalfilelist;
        this.resumeInfo.issponsorvisa = res.data.record.issponsorvisa;
        if (!this.isNotNullOrEmpty(this.resumeInfo.introduction)) {
          let path = this.$route.path
          if (path == "/portal/submitResume") {
            this.isShowMessageBox = true;
          }
        }
      }
    },
    cancel() {
      this.isShowMessageBox = false;
      this.$router.push({
        path: "/portal/portList",
        query: {},
      });
    },
    confirm() {
      this.isShowMessageBox = false;
      this.$router.push({
        path: "/portal/information",
        query: {
          resumeid: this.resumeInfo.resumeid,
          isFillProfile: true,
          uuid: this.uuid,
          rcid: this.rcid
        },
      });
    },
  },
  mounted() {
    this.goTop();
  },
  created() {
    this.doLoadRecord();
    this.loadResumeList();
    this.findChannel();
    this.getBaseInfo();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/submitResume.vue